"use client";

import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

type FadeDivProps = {
  children: React.ReactNode;
  className?: string;
};

const BASE_DELAY = 0.2;
const DELAY_FACTOR = 0.0005;

export default function FadeDiv({ children, className }: FadeDivProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [delay, setDelay] = useState(BASE_DELAY);

  useEffect(() => {
    function updateDelay() {
      const rect = ref.current?.getBoundingClientRect();
      if (rect) {
        const xOffset = rect.left;
        const yOffset = rect.top - window.innerHeight;
        setDelay(BASE_DELAY + (xOffset + yOffset) * DELAY_FACTOR);
      }
    }

    updateDelay();
    window.addEventListener("scroll", updateDelay, { passive: true });
    window.addEventListener("resize", updateDelay);

    return () => {
      window.removeEventListener("scroll", updateDelay);
      window.removeEventListener("resize", updateDelay);
    };
  }, []);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
